import { baseURL } from "../../../constants"
import {postRequest} from "../../../utils/requestFunctions"

export async function handleFavoritesChange(jwt, pageID, pageTitle, target, value){
    // TODO: all urls into constants
    const response = await postRequest(jwt, baseURL + "/favoritePages", { 
            pageID: pageID, 
            pageTitle: pageTitle,
            target: target, 
            value: value
        })
}

